import { InjectionToken } from '@angular/core';

export const NON_REDIRECTED_URLS_AFTER_LOGIN_TOKEN = new InjectionToken<string[]>('non-redirected-urls-after-login');
